import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Text, useToggle } from '@factorialco/deprecated-design-system'

import type { PopoverMenuTouchableOptionProps as Option } from 'modules/core/components/PopoverMenu'
import Popover from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type OverlapPeriod from 'modules/work_schedules/store/models/OverlapPeriod'

interface Props {
  period: OverlapPeriod
  itemName: string
}

const Item = ({ period, itemName }: Props) => {
  const [_open, toggle] = useToggle(false)
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const parseDate = (date: string) => stringToDate(date, 'backend').format('MMMM D')

  const { start_date: startDate, end_date: endDate, id, schedule_id: scheduleId } = period.toJS()

  const options: Option[] = [
    {
      title: i18n.t('settings.work_schedule.period_section.popover.edit'),
      onClick: () =>
        navigate(
          navigation.settings.workSchedule.id.periodPeriodId.fullPath({
            id: +scheduleId,
            periodId: +id,
          })
        ),
    },
    {
      title: i18n.t('settings.work_schedule.period_section.popover.delete'),
      danger: true,
      onClick: () =>
        navigate(
          navigation.settings.workSchedule.id.edit.periodPeriodIdDelete.fullPath({
            id: +scheduleId,
            periodId: +id,
          })
        ),
    },
  ]

  const ActionButton = () => (
    <Popover type="list">
      <Popover.Trigger>
        <Button onClick={toggle(true)} type="secondary" iconName="settings" />
      </Popover.Trigger>
      <Popover.Content side="bottom" align="end">
        {options.map((option, index) => {
          return (
            <Popover.TouchableOption
              key={index}
              onClick={option.onClick}
              title={option.title}
              danger={option.danger}
            />
          )
        })}
      </Popover.Content>
    </Popover>
  )

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      justifyContent="spaceBetween"
      padding="s16"
      width="full"
    >
      <Box flexDirection="column">
        <Text.Normal weight="medium">{itemName}</Text.Normal>
        <Text.Normal size="200">
          {parseDate(startDate)} - {parseDate(endDate)}
        </Text.Normal>
      </Box>
      <ActionButton />
    </Box>
  )
}

export default Item
